import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Layouts/Header";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import * as action from "../Services/redux/reducer";

const MainLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const sessionStorageState = JSON.parse(sessionStorage.getItem("user"));

  const islogin = useSelector((state) => state.islogin);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsOpen(false); // Close sidebar when screen width is less than or equal to 768px
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Cleanup function
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array means this effect runs only once after initial render
  useEffect(() => {
    if (islogin) {
      // navigate("/allJobs");
    } else {
      navigate("/login");
    }
  }, [islogin]);

  function checkTokenExpiration(token) {
    try {
      const decodedToken = jwtDecode(token);
      if (!decodedToken) {
        return false;
      }
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp < currentTime) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      return false;
    }
  }

  useEffect(() => {
    if (sessionStorageState) {
      const isTokenExpired = checkTokenExpiration(
        sessionStorageState?.user?.accessToken
      );
      if (isTokenExpired) {
        Logout();
      }
    }
  }, []);

  function Logout() {
    dispatch(action.Loading({ Loading: true }));
    dispatch(
      action.Auth({
        user: null,
        islogin: false,
      })
    );

    sessionStorage.removeItem("user");

    setTimeout(() => {
      navigate("/login");
      dispatch(action.Loading({ Loading: false }));
    }, 500);
  }
  return (
    islogin && (
      <div className={` bg-gray-200 flex flex-row fixed w-full `}>
        <Sidebar isOpen={isOpen} toggleSidebar={() => toggleSidebar()} />
        <div className="w-full bg-gray-200 h-screen  relative overflow-scroll">
          <Header toggleSidebar={() => toggleSidebar()} isOpen={isOpen} />
          <div className="md:px-7 px-3 pb-8  md:pt-7">{<Outlet />}</div>
        </div>
      </div>
    )
  );
};

export default MainLayout;
